<template>
  <div>
    <input-field label="数据 ID" v-model="dataId" :disabled="!editable"></input-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  import InputField from '@/components/utils/input-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'plc-device-data',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        dataId: ''
      }
    },
    components: {
      InputField,
      SubmitField
    },
    computed: {
      isValid () {
//        return !!this.dataId
        return true
      }
    },
    methods: {
      refresh () {
        this.dataId = this.defaults.dataId
      },
      submit () {
        this.$emitter.emit(this.event, {
          _id: this.defaults._id,
          dataId: this.dataId
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/dlt645-data.vue